import { BackOfficeCommentsTable } from "../../BackOfficeCommentsTable";
import { DataHeader, DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsRates extends Layout {
    dataheaderCommissionsRates: DataHeader;
    labelRates: Label;
    layoutBackOfficeCommentsTable: BackOfficeCommentsTable;
    panelContent: Panel;
    panelRates: Panel;
    sourceComments: DataSource;
    sourceCommissionRate: DataSource;
    sourceCommissionRatePerOrder: DataSource;
    sourceCommissionRateTier: DataSource;
    tabComments: Tab;
    tableRatesPerOrder: Table;
    tableRatesTieredBoth: Table;
    tableRatesTieredCommMargin: Table;
    tableRatesTieredOrderCount: Table;
    tabsetComments: Tabset;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxRateType: Textbox;
    textboxTieredRateBasis: Textbox;
}
